var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSegment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 513.32 513.32",
    style: {
      enableBackground: "new 0 0 513.32 513.32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M384.99,32.083H128.33v171.107h256.66V32.083z M342.213,160.413H171.107V74.86h171.107L342.213,160.413L342.213,160.413z "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "85.553,288.742 235.272,288.742 235.272,331.52 278.048,331.52 278.048,288.742 427.767,288.742 427.767,331.52  470.543,331.52 470.543,245.967 42.777,245.967 42.777,331.52 85.553,331.52  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M384.99,352.908v128.33h128.33v-128.33L384.99,352.908L384.99,352.908z M470.543,438.461h-42.777v-42.777h42.777V438.461 z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M192.495,481.237h128.33v-128.33h-128.33L192.495,481.237L192.495,481.237z M235.272,395.685h42.777v42.777h-42.777 V395.685z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0,481.237h128.33v-128.33H0V481.237z M42.777,395.685h42.777v42.777H42.777V395.685z"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSegment);
export default __webpack_public_path__ + "static/media/segment.5a7c3fad2fd536df9f17eb7e9259dcff.svg";
export { ForwardRef as ReactComponent };